<script>
import useVuelidate from '@vuelidate/core';
import {helpers, maxLength, required} from '@vuelidate/validators';

/* COMPONENTS */
import GaTripleView from '@components/v2/layout/GaTripleView.vue';
import AkPictureAccommodation from '@components/v2/general/AkPictureAccommodation.vue';
import AkAvatar from '@components/general/AkAvatar.vue';
import AkButtonActionValidation from '@components/v2/general/AkButtonActionValidation.vue';
import PrestationBadge from '@components/general/PrestationBadge.vue';
import AkFicListColRight from '@components/v2/general/AkFicListColRight.vue';
import DropdownMenu from 'v-dropdown-menu';
import AkFormSubmitted from '@components/general/AkFormSubmitted.vue';
import AkInputText from '@components/v2/input/AkInputText.vue';
import AkDialog from '@components/general/AkDialog.vue';
import AkButtonActionV2 from '@components/v2/general/AkButtonActionV2.vue';
import GaTabView from '@components/v2/layout/GaTabView.vue';
import HousekeeperAccommodations from '@views/housekeepers/tabs/HousekeeperAccommodations.vue';
import HousekeeperAccommodationsHistory from '@views/housekeepers/tabs/HousekeeperAccommodationsHistory.vue';

/* MIXINS */
import backMixin from '@mixins/backMixin';
import messageMixin from '@mixins/messageMixin';
import civilitiesConst from '@mixins/const/civilitiesConst';
import utilsMixin from '@mixins/utilsMixin';
import companyMixin from '@mixins/companyMixin';
import loaderMixin from '@mixins/loaderMixin';
import permissionsMixin from '@mixins/permissionsMixin';
import validatorMixins from '@mixins/validatorMixins';
import housekeeperTabMixin from '@mixins/tab/housekeeperTabMixin';

/* SERVICES */
import housekeeperService from '@services/housekeeperService';
import itemLabelService from '@services/itemLabelService';
import ficService from '@services/ficService';

export default {
  components: {
    AkButtonActionV2,
    AkDialog,
    AkInputText,
    AkFormSubmitted,
    AkFicListColRight,
    PrestationBadge,
    AkButtonActionValidation,
    AkAvatar,
    AkPictureAccommodation,
    GaTripleView,
    DropdownMenu,
    GaTabView,
    HousekeeperAccommodationsHistory,
    HousekeeperAccommodations,
  },
  mixins: [
    permissionsMixin,
    backMixin,
    messageMixin,
    civilitiesConst,
    utilsMixin,
    companyMixin,
    loaderMixin,
    validatorMixins,
    housekeeperTabMixin,
  ],
  head() {
    return {
      title: this.title,
    };
  },
  setup() {
    return {v$: useVuelidate()};
  },
  validations() {
    return {
      email: {
        required,
        maxLengthValue: maxLength(100),
        email: helpers.withMessage(
          "Le format de l'adresse e-mail est invalide. Veuillez vérifier et réessayer (ex. : nom@domaine.com)",
          this.emailValidator,
        ),
      },
    };
  },
  data() {
    return {
      housekeeper: {
        companyId: null,
        contact: {
          companyName: null,
          formeJuridiqueId: null,
          raisonSociale: null,
          capital: null,
          address: null,
          complement: null,
          postalCode: null,
          city: null,
          state: null,
          country: null,
          email: null,
          phone: null,
          villeRcs: null,
          siret: null,
          civility: null,
          lastName: '',
          firstName: '',
          function: null,
        },
      },
      editable: false,

      listFormeJuridique: [],

      email: null,
      previousEmail: null,
      submitted: false,
    };
  },
  mounted() {
    this.initGoBack();
    this.refresh();
  },
  methods: {
    reloadFiles() {
      ficService.fics({tableName: 'housekeeper', tableId: this.housekeeper.id}).then((data) => {
        this.housekeeper.files = data;
      });
    },
    refresh() {
      this.showTotalLoaderGuestadom();

      const promiseList = [];

      let p1 = housekeeperService.housekeeper(this.$route.params.housekeeperId);
      p1.then((result) => {
        this.housekeeper = result;
        return this.reloadFiles();
      });
      promiseList.push(p1);

      let p2 = itemLabelService.itemLabels({type: 'FORME_JURIDIQUE'});
      p2.then((data) => {
        this.listFormeJuridique = data;
      });
      promiseList.push(p2);

      Promise.all(promiseList)
        .catch((e) => {
          this.onError(e);
        })
        .finally(() => {
          this.hideLoader();
        });
    },
    generateAccess() {
      housekeeperService
        .access(this.housekeeper)
        .then((data) => {
          this.housekeeper = data;
          this.success(this.$t('housekeeper.accessSent'));
        })
        .catch((e) => {
          this.onError(e);
        })
        .finally(() => {
          if (this.$refs.btnAccess) this.$refs.btnAccess.init();
        });
    },
    enableHousekeeper() {
      housekeeperService
        .enable(this.housekeeper)
        .then((data) => {
          this.housekeeper = data;
          this.housekeeper.userEnabled = true;
          this.success(this.$t('housekeeper.enabled'));
        })
        .catch((e) => {
          this.onError(e);
        })
        .finally(() => {
          if (this.$refs.btnEnable) this.$refs.btnEnable.init();
        });
    },
    disableHousekeeper() {
      housekeeperService
        .disable(this.housekeeper)
        .then((data) => {
          this.housekeeper = data;
          this.housekeeper.userEnabled = false;
          this.success(this.$t('housekeeper.disabled'));
        })
        .catch((e) => {
          this.onError(e);
        })
        .finally(() => {
          if (this.$refs.btnDisable) this.$refs.btnDisable.init();
        });
    },
    showEmailUpdateDialog() {
      this.previousEmail = this.housekeeper.contact.email;
      this.submitted = false;
      this.email = null;
      this.$refs.updateEmailDialog.show();
    },
    updateEmail() {
      this.submitted = true;
      this.v$.email.$touch();
      if (this.v$.email.$error) {
        this.$refs.updateEmailDialog.init();
        return;
      }

      housekeeperService
        .updateEmail(this.housekeeper.id, this.email)
        .then(() => {
          this.housekeeper.contact.email = this.email;

          this.addSuccess("L'adresse mail du concierge partenaire a été modifiée avec succès");
          this.$refs.updateEmailDialog.cancel();
        })
        .catch((e) => {
          this.$refs.updateEmailDialog.init();
          if (e.response.data.error === 'USER_MAIL_ALREADY_EXISTS')
            this.$refs.updateEmailDialog.error(
              "L'adresse mail saisie est déjà enregistrée dans l'application. Merci de vérifier le champ E-mail.",
            );
          else this.$refs.updateEmailDialog.error('Une erreur est survenu, merci de réessayer.');
        });
    },

    onError(error) {
      const message = this.msgForErr(this.$t, error);
      this.addError(message);
    },
  },
  computed: {
    title() {
      return this.housekeeper.contact.firstName + ' ' + this.housekeeper.contact.lastName;
    },
  },
};
</script>

<template>
  <GaTripleView>
    <template #action>
      <AkButtonActionValidation
        v-if="!housekeeper.userEnabled"
        ref="btnEnable"
        :label="$t('enable')"
        :messagePopup="$t('confirm_enable', [this.housekeeper.display])"
        :titlePopup="$t('confirm_dialog')"
        success
        @click="enableHousekeeper" />
      <AkButtonActionValidation
        v-if="housekeeper.userEnabled"
        ref="btnDisable"
        :label="$t('disable')"
        :messagePopup="$t('confirm_disable', [this.housekeeper.display])"
        :titlePopup="$t('confirm_dialog')"
        danger
        @click="disableHousekeeper" />

      <AkButtonActionValidation
        v-if="!housekeeper.userId && housekeeper.userEnabled"
        ref="btnAccess"
        :label="$t('housekeeper.createAccess')"
        :messagePopup="$t('housekeeper.create_access_confirmation')"
        :titlePopup="$t('confirm_dialog')"
        secondary
        @click="generateAccess" />
      <AkButtonActionValidation
        v-if="housekeeper.userId && housekeeper.userEnabled"
        ref="btnAccess"
        :label="$t('housekeeper.resendAccess')"
        :messagePopup="$t('housekeeper.resend_access_confirmation')"
        :titlePopup="$t('confirm_dialog')"
        secondary
        @click="generateAccess" />

      <dropdown-menu :overlay="false" direction="right" class="accommodation" v-if="housekeeper.id">
        <template #trigger>
          <span class="btn-primary xs">Modifier</span>
        </template>
        <template #body>
          <ul>
            <li class="py-2">
              <router-link
                class="text-grey-400 font-medium font-inter text-base md:hover:text-grey-900"
                :to="{name: 'housekeeperUpdate', params: {housekeeperId: housekeeper.id}}"
                >{{ $t('housekeeper.updateThis') }}
              </router-link>
            </li>
            <li class="py-2">
              <AkButtonActionV2
                label="Modifier l'e-mail"
                class="text-grey-400 font-medium font-inter !bg-transparent !p-0 ext-base md:hover:text-grey-900"
                @click="showEmailUpdateDialog" />
            </li>
          </ul>
        </template>
      </dropdown-menu>
    </template>
    <template #left>
      <div class="flex flex-col gap-4 md:gap-2">
        <div class="w-[160px] self-center">
          <AkAvatar
            v-if="housekeeper.userId"
            ref="avatar"
            :first-name="housekeeper.contact.firstName"
            :last-name="housekeeper.contact.lastName"
            :user-id="housekeeper.userId" />
        </div>

        <div class="flex items-center gap-2 mt-3">
          <i
            class="ga-icon ga-chevron_down text-grey-900 text-2xl md:hover:cursor-pointer"
            @click="toggleElement(this.$refs, 'contact', $event)" />
          <span class="font-inter text-grey-900 font-semibold text-lg">Contact</span>
        </div>
        <div ref="contact">
          <div class="grid grid-cols-2 mt-4 gap-4 md:gap-2">
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.formeJuridique') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                listFormeJuridique.find((f) => f.id === housekeeper.contact.formeJuridiqueId)?.label
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.raisonSociale') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.raisonSociale
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.companyName') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.companyName
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">Capital (€)</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.capital
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.villeRcs') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.villeRcs
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.siret') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.siret
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.civility') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                displayForCivilityConst(housekeeper.contact.civility)
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.functionManager') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.function
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.lastNameManager') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.lastName
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.firstNameManager') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.firstName
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.email') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.email
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.phone') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                housekeeper.contact.phone
              }}</span>
            </div>
            <div v-if="isGas() || isAdmin()" class="flex flex-col gap-1 col-span-2">
              <span class="font-inter font-semibold text-grey-900 text-base">Agence</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                displayForCompany(housekeeper.companyId)
              }}</span>
            </div>
          </div>
        </div>

        <div class="flex items-center gap-2 mt-3">
          <i
            class="ga-icon ga-chevron_down text-grey-900 text-2xl md:hover:cursor-pointer"
            @click="toggleElement(this.$refs, 'bank', $event)" />
          <span class="font-inter text-grey-900 font-semibold text-lg">Informations complémentaires</span>
        </div>
        <div ref="bank">
          <div class="grid grid-cols-2 mt-4 gap-4 md:gap-2">
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('mandat.iban') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-all">{{ housekeeper.iban }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('mandat.bic') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-all">{{ housekeeper.bic }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('date_updated') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base">{{
                this.formatDateIfNeeded(housekeeper.dateUpdatedBankInfo)
              }}</span>
            </div>
            <div class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('updated_by') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base">{{ housekeeper.updatedBy }}</span>
            </div>
          </div>
        </div>

        <div class="flex items-center gap-2 mt-3">
          <i
            class="ga-icon ga-chevron_down text-grey-900 text-2xl md:hover:cursor-pointer"
            @click="toggleElement(this.$refs, 'address', $event)" />
          <span class="font-inter text-grey-900 font-semibold text-lg">Adresse</span>
        </div>
        <div ref="address">
          <div :class="housekeeper.contact.address ? 'grid-cols-2' : 'grid-cols-1'" class="grid mt-4 gap-4 md:gap-2">
            <template v-if="housekeeper.contact.address">
              <div class="flex flex-col gap-1">
                <span class="font-inter font-semibold text-grey-900 text-base">{{
                  $t('contact.address1Manager')
                }}</span>
                <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                  housekeeper.contact.address
                }}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('address.complement') }}</span>
                <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                  housekeeper.contact.complement
                }}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('address.postalCode') }}</span>
                <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                  housekeeper.contact.postalCode
                }}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('address.city') }}</span>
                <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                  housekeeper.contact.city
                }}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('address.state') }}</span>
                <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                  housekeeper.contact.state
                }}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('address.country') }}</span>
                <span class="font-inter font-medium text-grey-400 text-base break-words">{{
                  housekeeper.contact.country
                }}</span>
              </div>
            </template>
            <div v-else class="flex flex-col gap-1">
              <span class="font-inter font-semibold text-grey-900 text-base">{{ $t('contact.address1Manager') }}</span>
              <span class="font-inter font-medium text-grey-400 text-base break-words">Adresse inconnue</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <GaTabView
        v-if="housekeeper.id != null"
        ref="tabView"
        :firstTab="this.getActiveTab"
        :tabs="this.getTabs"
        @tab="this.setActiveTab">
        <!-- Logements -->
        <template #housekeeperAccommodations>
          <HousekeeperAccommodations v-model="housekeeper" @error="onError" />
        </template>
        <!-- Historique des affectations -->
        <template #housekeeperAccommodationsHistory>
          <HousekeeperAccommodationsHistory v-model="housekeeper" @error="onError" />
        </template>
      </GaTabView>
    </template>
    <template #right>
      <AkFicListColRight
        v-if="housekeeper.id != null"
        v-model="housekeeper.files"
        :table-id="housekeeper.id"
        can-delete
        can-upload
        table-name="housekeeper"
        title="Pièces jointes" />
    </template>
  </GaTripleView>

  <AkDialog title="Modifier l'e-mail" ref="updateEmailDialog" :validate-label="$t('modify')" @validate="updateEmail">
    <AkFormSubmitted :submitted="submitted" class="flex flex-col gap-2">
      <AkInputText v-model="this.previousEmail" label="Ancienne adresse mail" disabled />
      <AkInputText v-model="this.email" :validator="v$.email" label="Nouvelle adresse mail" autofocus />
    </AkFormSubmitted>
  </AkDialog>
</template>
